export enum ChapterHistoryTableTypes {
    historyTableTitle = 'History',
    EffectiveLabel = 'Effective:',
    DeleteHistoryItemTitle = 'Delete History Item',
    DeleteHistoryItemWarning = 'Are you sure you want to delete this history item? This action cannot be undone.'
}